module.exports = __webpack_public_path__ + "static/media/ignitingBusiness.9304e0bf.png";